import axios from "@/services/axios";
import store from "../store";

export const sendInquiry = (data) => {
    return axios.post('website/send_lot_inquiry', data)
  }

  export const errorReporting = (event, code, message, extraData) => {
    const mainConfig = store.state.mainConfig;
    if (typeof mainConfig.errorReportingCallback !== 'function') {
      return;
    }
    extraData['customer'] = store.state.customer;
    setTimeout(() =>{
      mainConfig.errorReportingCallback(event, code, message, extraData);
    }, 0)
  }
